import { useMemo } from 'react';
import { Table, useQueryState, formatBalance } from '@ui/src';
import Card from '../partial/card/card';
import { Balance, PspAccountItem } from '../../hoc/bank-and-psp/types';
import {
  internalAccountsColumns,
  internalAccountsSchema,
} from '../../hoc/bank-and-psp/variables/internal-accounts';
import { InternalAccountsTypes } from './types';

import cn from './info.module.css';

const formatInternalAccountList = (
  list: PspAccountItem[],
  balances?: Balance[],
): PspAccountItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      currencyId: (
        <div className={cn.internalAccountBalances}>
          {balances
            ?.filter((balance) => balance?.accountId === item.account.id)
            ?.map((balance) => (
              <div key={balance.id}>{`${formatBalance(
                balance?.value || 0,
                balance.currency,
              )} ${balance.currency.name}`}</div>
            ))}
        </div>
      ),
      accountId: <div>{item.account.fullNumber}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

const InternalAccounts = ({
  internalAccounts,
  isLoading,
  internalAccountsErrors,
  balances,
}: InternalAccountsTypes) => {
  const { sort } = useQueryState(internalAccountsSchema);

  const formattedData = useMemo(() => {
    const data = formatInternalAccountList(
      internalAccounts as PspAccountItem[],
      balances,
    );

    return data;
  }, [internalAccounts, sort, balances]);

  return (
    <Card
      className={cn.documentsCard}
      isLoading={isLoading}
      title="Internal accounts"
    >
      <Table
        columns={internalAccountsColumns}
        data={formattedData || []}
        error={internalAccountsErrors}
        onSort={() => {}}
        filters={{}}
        sort={sort}
        isLoading={isLoading}
        columnsLabels={{}}
        onFilterChange={() => {}}
        tableBodyClassName={
          !isLoading && !internalAccounts?.length ? cn.emptyInternalTable : ''
        }
      />
    </Card>
  );
};

export default InternalAccounts;
